module.exports = __webpack_public_path__ + "b922dc235c9d37381bf102c2e8358471.pdf";